import React, { useState } from "react";
import TitleBar from "../../../components/TitleBar";
import Alert from '@mui/material/Alert';
import Grid from "@mui/material/Grid";
import { toast } from "react-toastify";
import CloseForm2 from "./CloseForm2";
import CloseForm3 from "./CloseForm3";
import CloseForm4 from "./CloseForm4";
import CloseForm5 from "./CloseForm5";
import Confirm from "./Confirm";

function CloseForm1({
  tripId,
  vtr_nbr,
  permitNbr,
  tripType,
  projectCode,
  returnedErrors,
  onClose,
}) {
  const [step, setStep] = useState(1);
  const [vtrnbr, setVtrnbr] = useState(vtr_nbr);
  const [portcd, setPortCD] = useState({});
  const [etaTripEnd, setEtaTripEnd] = useState(null);
  const [mnkfshOvrflg, setMnkfshFlg] = useState("false");
  const [catchList, setCatchList] = useState([]);
  const [editIdx, setEditIdx] = useState(-1);

  const deleteSpecies = (idx) => {
    const tmpCatch = catchList;
    tmpCatch.splice(idx, 1);
    setCatchList([...tmpCatch]);
  };

  const startEditing = (idx) => {
    setEditIdx(idx);
  };

  const stopEditing = () => {
    setEditIdx(-1);
  };

  const values = {
    tripid: tripId,
    permitNbr,
    tripType,
    projectCode,
    vtr_nbr,
    vtrnbr,
    portcd,
    etaTripEnd,
    mnkfshOvrflg,
    catchList,
    setCatchList,
    deleteSpecies,
    editIdx,
    startEditing,
    stopEditing,
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const goToStep = (step) => {
    setStep(step);
  };

  const checkCatchExists = (newCatch) => {
    return catchList.some((obj) => obj.id === `${newCatch.id}`);
  };

  const handleChange = (input) => (event, reason) => {
    let newCatch = [...values.catchList];

    if (input === "vtrnbr") setVtrnbr(event.target.value);
    else if (input === "etaTripEnd") setEtaTripEnd(event);
    else if (input === "port") {
      if (reason) {
        if (reason.hasOwnProperty("id") && reason.hasOwnProperty("label")) {
          setPortCD({ id: reason.id, name: reason.label, state: reason.state });
        }
      } else {
        setPortCD({});
      }
    } else if (input === "mnkfshOvrflg") setMnkfshFlg(event.target.value);
    else if (input === "catch") {
      if (!reason) {
        newCatch[editIdx] = {
          ...newCatch[editIdx],
          [event.target.name]: event.target.value,
        };
      } else {
        if (checkCatchExists(reason)) {
          toast.error("The Species was previously added.", {
            autoClose: false,
          });
          return;
        }
        newCatch[editIdx] = {
          ...newCatch[editIdx],
          id: reason.id,
          name: reason.label,
        };
      }
      setCatchList([...newCatch]);
      console.log("newObject", newCatch, catchList);
    }
  };

  const handleConfirm = (values) => {
    onClose(values);
  };

  return (
    <>
      <TitleBar title="RSA Close Trip Hail" />
      <Grid item xs={12} md={7}>
        {returnedErrors.onSubmitted && (
          <Alert severity="error">{returnedErrors.onSubmitted}</Alert>
        )}
      </Grid>
      <div style={{ width: "100%" }}>
        {
          {
            1: (
              <CloseForm2
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            2: (
              <CloseForm3
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            3: (
              <CloseForm4
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            4: (
              <CloseForm5
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            5: (
              <Confirm
                prevStep={prevStep}
                goToStep={goToStep}
                handleConfirm={handleConfirm}
                values={values}
              />
            ),
          }[step]
        }
      </div>
    </>
  );
}

export default CloseForm1;
